import { Head } from "@inertiajs/react"

import { RoleForm } from "@/components/admin/role-form"
import AppLayout from "@/layouts/app-layout"
import { adminRolesPath, newAdminRolePath } from "@/routes"
import type { BreadcrumbItem, PermissionCatalog } from "@/types"

interface Props {
  available_permissions: PermissionCatalog
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Roles", href: adminRolesPath() },
  { title: "New", href: newAdminRolePath() },
]

export default function New({ available_permissions }: Props) {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="New Role" />

      <div className="max-w-4xl space-y-6 p-6">
        <div>
          <h1 className="text-2xl font-semibold">New Role</h1>
          <p className="text-muted-foreground text-sm">
            Start with the portal the role needs, then tick what it may do
            there.
          </p>
        </div>

        <RoleForm
          action={adminRolesPath()}
          method="post"
          availablePermissions={available_permissions}
          submitLabel="Create Role"
        />
      </div>
    </AppLayout>
  )
}
